import i18n from "../../i18n/index";
import copaymentService from "../../services/copayment/CopaymentService";

export default {
  components: {
  },
  data: () => ({
    headers: [{
      text: i18n.t('headers.plu'),
      sortable: true,
      value: 'plu'
    },
    {
      text: i18n.t('headers.internal-code'),
      sortable: true,
      value: 'internalCode'
    },
    {
      text: i18n.t('headers.description'),
      sortable: true,
      value: 'description'
    },
    {
      text: i18n.t('headers.groupA'),
      sortable: false,
      value: 'groupA'
    },
    {
      text: i18n.t('headers.groupB'),
      sortable: false,
      value: 'groupB'
    },
    {
      text: i18n.t('headers.groupC'),
      sortable: false,
      value: 'groupC'
    }
    ],
    providers: [],
    provider: {
      id: '',
      name: '',
      fiscalNumber: '',
      active: ''
    },
    copayments: [],
    searchTerm: '',
    file: '',
    selectedProviderId: '',
    loaded: false,
    templateLink: 'http://104.248.183.112:3001/template/copayment',
    loading: false
  }),
  created() {
    this.selectedProviderId = JSON.parse(localStorage.getItem('user'))
    this.selectedProviderId = this.selectedProviderId.providerId
    this.loading = true
    this.getCopayment(this.selectedProviderId)
    this.loading = false
  },

  computed: {
  },

  watch: {
  },

  methods: {
    async getCopayment(idProvider) {
      const aux = await copaymentService.getCopayment(idProvider)
      this.copayments = aux.data
    },
    onChangeFileUpload() {
      if (this.$refs.file.files[0] !== undefined) {
        this.file = this.$refs.file.files[0]
        this.loaded = true
      } else {
        this.loaded = false
      }
    },
    async submitForm() {
      if (this.file !== undefined && this.file !== '') {
        this.loading = true
        let data = await copaymentService.updateCopayment(this.file, this.selectedProviderId)
        if (data.data == 'Missing data') {
          this.loading = false
          this.$notify({
            group: 'app',
            type: 'error',
            text: i18n.t('copayment.bad-excel')
          })
        } else if (data.data == 'Missing file') {
          this.loading = false
          this.$notify({
            group: 'app',
            type: 'error',
            text: i18n.t('copayment.no-file')
          })
        } else {
          this.getCopayment(this.selectedProviderId)
          this.loading = false
        }
      } else {
        this.$notify({
          group: 'app',
          type: 'error',
          text: 'No ha cargado el archivo de copagos'
        })
      }
    }
  }
}
